import _ from 'lodash';
import React, { useContext } from 'react';
import { MainNavContext } from '../../MobileNav/MobileNavContainer';
export var SearchOrigin;
(function (SearchOrigin) {
    SearchOrigin["UNKNOWN"] = "(unknown)";
    SearchOrigin["HOME"] = "home";
    SearchOrigin["TOP_NAV"] = "top_nav";
    SearchOrigin["FILTERS"] = "filters";
    SearchOrigin["SEARCH_BAR"] = "search_bar";
    SearchOrigin["SORT_BY"] = "sort_by";
    SearchOrigin["TYPE_AHEAD"] = "type_ahead";
    SearchOrigin["STOCK_ITEM_CARD"] = "stock_item_card";
    SearchOrigin["DETAILS_PAGE"] = "details_page";
    SearchOrigin["RELATED_SEARCH"] = "related-search";
    SearchOrigin["PAGINATION"] = "pagination";
    SearchOrigin["ARTIST"] = "artist";
    SearchOrigin["APPLIED_FILTERS"] = "applied_filters";
    SearchOrigin["AUTOCORRECT"] = "autocorrect";
})(SearchOrigin || (SearchOrigin = {}));
export function linkWithOrigin(event, url, searchOrigin = SearchOrigin.TOP_NAV) {
    event.preventDefault();
    const appendChar = url.includes('?') ? '&' : '?';
    window.location.href = `${url}${appendChar}search-origin=${searchOrigin}`;
}
function telemetryCollectionAction(url) {
    const urlArr = (url || '').split('/');
    const slug = urlArr.length > 0 ? urlArr[urlArr.length - 1] : '';
    const telemetrySlug = `nav.clicked.collections.${slug}`;
    const { logger } = useContext(MainNavContext);
    logger(telemetrySlug);
}
export const getBrowseLink = (url, children, className = '', id = '') => {
    const isSearchLink = /\/(video|audio|images)\/search/.test(url);
    // the below regex will only match specific collection pages, like /collections/authentic-collections
    // not the home collection page /collections
    const isCollectionLink = /\/(video|audio|images)\/collections\/[a-z0-9\-]+/.test(url);
    let onClick = _.noop;
    if (isSearchLink) {
        onClick = linkWithOrigin;
    }
    else if (isCollectionLink) {
        onClick = telemetryCollectionAction;
    }
    return (<a href={url} id={id} className={className} tabIndex={0} onClick={(evt) => onClick(evt, url)}>
      {children}
    </a>);
};
export const BrowseLink = ({ url, children, className, id }) => getBrowseLink(url, children, className, id);
